<template>
  <div class="quen-unlock-widget-edit">
    <!-- 活动选择 -->
    <menu-item label="活动">
      <activity-select v-model="model.bizId" :type="14" />
    </menu-item>

    <!-- 背景设置 -->
    <menu-item :label="$t('head.backImg')" class="menu-item-switch" pt="0px">
      <menu-fill :target="model.background" target-key="background" />
      <menu-background-image class="mt-2" :target="model.background" target-key="background" />
    </menu-item>
    <menu-divider />
    <!-- 布局 -->
    <menu-item :label="$t('menu.layout')" class="menu-item-switch" pt="0px">
      <menu-switch v-model="model.titleVisible" label="标题" target-key="titleVisible" />
      <menu-switch v-model="model.subtitleVisible" class="mt-2" label="描述" target-key="subtitleVisible" />
    </menu-item>

    <!-- 商品卡片背景 -->
    <menu-item label="商品卡片背景">
      <menu-background-image :target="model.cardBackground" target-key="cardBackground" />
      <menu-fill class="mt-2" :target="model.cardBackground" target-key="cardBackground" />
    </menu-item>

    <!-- 商品LOGO背景 -->
    <menu-item label="商品LOGO背景">
      <menu-background-image :target="model.logoBackground" target-key="logoBackground" />
      <menu-fill class="mt-2" :target="model.logoBackground" target-key="logoBackground" />
    </menu-item>

    <!-- 商品文字色 -->
    <menu-item label="商品文字色">
      <menu-fill :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>

    <!-- 圆角 -->
    <menu-item label="圆角">
      <menu-slider v-model="model.radius" target-key="radius" />
    </menu-item>

    <!-- 免费按钮填充/文字色 -->
    <menu-item label="免费按钮填充">
      <menu-background-image :target="model.freeButtonBackground" target-key="freeButtonBackground" />
      <menu-fill class="mt-2" :target="model.freeButtonBackground" target-key="freeButtonBackground" />
    </menu-item>
    <menu-item label="免费按钮文字色">
      <menu-fill :target="model.freeButtonTextColor" solid-color target-key="freeButtonTextColor" />
    </menu-item>

    <!-- 购买按钮填充/文字色 -->
    <menu-item label="购买按钮填充">
      <menu-background-image :target="model.buyButtonBackground" target-key="buyButtonBackground" />
      <menu-fill class="mt-2" :target="model.buyButtonBackground" target-key="buyButtonBackground" />
    </menu-item>
    <menu-item label="购买按钮文字色">
      <menu-fill :target="model.buyButtonTextColor" solid-color target-key="buyButtonTextColor" />
    </menu-item>

    <!-- 连线箭头填充 -->
    <menu-item label="连接线ICON">
      <menu-background-image :target="model.arrowBackground" target-key="arrowBackground" />
    </menu-item>

    <menu-item label="加锁ICON">
      <menu-background-image :target="model.lockBackground" image-size-key="" target-key="lockBackground" />
    </menu-item>

    <!-- 操作 -->
    <menu-button class="mt-4" icon="add" :help-text="$t('menu.copyBlock')" @click.native.stop="handleClone">{{ $t('menu.createCopy') }}</menu-button>
    <remove-btn class="mt-4" />
  </div>
 </template>

 <script>
 import ActivitySelect from '~/site/components/activitySelect/index.vue'
 import RemoveBtn from "~/components/common/RemoveBtn.vue";
 import MenuItem from "~/components/menu/menuItem.vue";
 import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";
 import MenuSwitch from "~/components/menu/menuSwitch.vue";
 import MenuFill from "~/components/menu/menuFill.vue";
 import MenuSlider from "~/components/menu/menuSlider.vue";
 import MenuDivider from "~/components/menu/divider";
 import MenuButton from "~/components/menu/menuButton.vue";

 export default {
  name: 'QuenUnlockWidgetEdit',
  components: { ActivitySelect, RemoveBtn, MenuItem, MenuBackgroundImage, MenuSwitch, MenuFill, MenuSlider, MenuDivider, MenuButton },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClone() {
      const cloned = this.model && this.model.clone ? this.model.clone() : JSON.parse(JSON.stringify(this.model || {}))
      this.$emit('clone', cloned)
    }
  }
 }
 </script>

 <style scoped lang="less">
 .quen-unlock-widget-edit {
 }
 </style>